import cx from 'classnames'
import moment from 'moment'
import { useCallback, useEffect, useRef, useState } from 'react'

import { Divider } from '../../shared/Divider/index.jsx'
import styles from '../shared/domain/domain.module.scss'

export const headerType = [ 'label', 'header' ]
export const staticType = headerType.concat([ 'plain' ])
export const detailsFields = [ 'details', 'details_optional' ]
export const initialFiltersData = {
  status: [ 'in-progress', 'not-started' ],
  page: []
}

export const initialFiltersDataCP = {
  issue: [ 'in-progress', 'not-started' ],
  action: [ 'in-progress', 'not-started' ],
  assignee: [],
  page: []
}
export function itemDetails (trend) {
  const items = [{
    id: 'cgassstiqz10c8m4of8swsc1k4iu8s',
    key: 'assignee',
    type: 'select',
    label: 'assignee',
    values: []
  },
  {
    id: 'cgassstiqz22nljrt7ob6u1txv2h0',
    key: 'status',
    type: 'select',
    label: 'status',
    values: []
  },
  {
    id: 'cgassstiqz1b5ri5expnp981is0iga',
    key: 'comment',
    type: 'input',
    label: 'comment',
    value: ''
  }]
  if (trend) {
    items.push({
      id: 'cgassstiqz1b5ri5expnp981is0igz',
      key: 'trend',
      type: 'select',
      label: 'trend',
      value: []
    })
  }
  return items
}
export const igaoPages = [{
  id: 'medications',
  name: 'Medications'
},
{
  id: 'insurances',
  name: 'Insurance'
},
{
  id: 'family_support',
  name: 'Family | Support'
},
{
  id: 'provider_network',
  name: 'Provider Network'
},
{
  id: 'diagnosis',
  name: 'Diagnosis'
},
{
  id: 'substance_use',
  name: 'Substance Use'
},
{
  id: 'admissions',
  name: 'Admissions'
},
{
  id: 'patient',
  name: 'Patient'
},
{
  id: 'resources',
  name: 'Resources'
},
{
  id: 'home_assessment',
  name: 'Home Assessment'
},
{
  id: 'maternity',
  name: 'Maternity'
},
{
  id: 'esas',
  name: 'ESAS +'
},
{
  id: 'lifestyle',
  name: 'Lifestyle'
},
{
  id: 'vitals',
  name: 'Vitals'
},
{
  id: 'review_of_systems',
  name: 'Review of Systems'
},
{
  id: 'general_documents',
  name: 'General Documents'
},
{
  id: 'goals',
  name: 'Goals'
},
{
  id: 'tribal',
  name: 'Tribal'
},
{
  id: 'csr',
  name: 'CSR'
}]

export function getLink (patientId, path, client) {
  const links = {
    'medications': `/patient/${client}/${patientId}/assessment/standardmedications`,
    'patient': `/patient/${client}/${patientId}/assessment/standarddemographicspatient`,
    'family_support': `/patient/${client}/${patientId}/assessment/standarddemographicssupport`,
    'insurances': `/patient/${client}/${patientId}/assessment/standarddemographicsinsurance`,
    'home_assessment': `/patient/${client}/${patientId}/assessment/standarddemographicshomeassessment`,
    'provider_network': `/patient/${client}/${patientId}/assessment/standarddemographicsmedical`,
    'diagnosis': `/patient/${client}/${patientId}/assessment/standardmedicaldiagnosis`,
    'admissions': `/patient/${client}/${patientId}/assessment/standardmedicalevents`,
    'resources': `/patient/${client}/${patientId}/assessment/standardsocialhistoryresources`,
    'substance_use': `/patient/${client}/${patientId}/assessment/standardsocialhistorysubstance`,
    'maternity': `/patient/${client}/${patientId}/assessment/standardmaternity`,
    'goals': `/patient/${client}/${patientId}/assessment/standardgoals`,
    'esas': `/patient/${client}/${patientId}/assessment/standardsymptomsesas`,
    'vitals': `/patient/${client}/${patientId}/assessment/standardvitals`,
    'review_of_systems': `/patient/${client}/${patientId}/assessment/standardsymptomsros`,
    'lifestyle': `/patient/${client}/${patientId}/assessment/standardsocialhistorylifestyle`,
    'tribal': `/patient/${client}/${patientId}/assessment/standardsocialhistorytribal`,
    'csr': `/patient/${client}/${patientId}/assessment/standardcsr`,
    'general_documents': `/patient/${client}/${patientId}/assessment/standarddocuments`,
    'obstetrical-history': `/patient/${client}/${patientId}/assessment/standardmaternity`,
    'current-pregnancy': `/patient/${client}/${patientId}/assessment/standardmaternity`
  }
  return links[path]
}

export const relationName = {
  medication: 'Medication',
  organization: 'Organization',
  coverage: 'Coverage',
  details: 'Details',
  details_optional: 'Details (Optional)',
  provider: 'Provider',
  family_support: 'Family | Support',
  diagnosis: 'Diagnosis',
  goal: 'Goal',
  substance: 'Substance',
  facility: 'Facility',
  durable_medical_equipment: 'Durable Medical Equipment'
}

export function getDetail (item) {
  const assignee = item.details.find(d => d.key === 'assignee')
  const status = item.details.find(d => d.key === 'status')
  const trend = item.details.find(d => d.key === 'trend')
  return {
    assignee,
    status,
    trend
  }
}

export function generateParamsString (i) {
  return `${i.description} ${i.goal} ${i.actions?.map(a => a.description)}`
}

export function cancelledOrCompleted (item) {
  const { status } = getDetail(item)
  return status.id === 'cancelled' || status.id === 'completed'
}

export function diffDate (startDate, endDate) {
  const timeDiff =
    moment(startDate)
      .startOf('day') -
    moment(endDate || new Date())
      .startOf('day')
  return timeDiff / (1000 * 3600 * 24)
}

const getWeight = i => {
  if (cancelledOrCompleted(i)) {
    return i.draft ? 1 : 2
  }
  return 0
}

export function sortAction (filtered) {
  let act = filtered
  if (act) {
    act = act.sort(
      (cur, next) => new Date(next.createdAt) - new Date(cur.createdAt)
    )
    act = act.sort(
      (cur, next) => diffDate(cur.dueDate) - diffDate(next.dueDate)
    )
    act = act.sort((cur, next) => next.urgent || false - cur.urgent || false)
    act = act.sort((cur, next) => getWeight(cur) - getWeight(next))
  }
  return act
}

export function findEqualIssue (relation, issues) {
  const relations = [ ...relation ]
  const getValue = rel => rel?.id
    ? rel.id
    : rel.value?.toLowerCase()

  const findEqualRel = rel => {
    const relationExists = relations?.find(_rel => _rel.key === rel
      .key)

    if (!relationExists) {
      return false
    }

    return getValue(rel) === getValue(relationExists)
  }

  return issues?.filter(i => {
    return !cancelledOrCompleted(i) &&
      i.relations?.length === relation?.length &&
      i.relations?.filter(rel => findEqualRel(rel)).length === relation.length
  })
}

export function uid () {
  const a = new Uint32Array(3)
  window.crypto.getRandomValues(a)
  return (
    performance.now()
      .toString(36) +
    Array.from(a)
      .map(A => A.toString(36))
      .join('')
  )
    .replace(/\./g, '')
}

export function capitalize (s) {
  if (typeof s !== 'string' || s.length <= 0) {
    return ''
  }
  return s[0].toUpperCase() + s.slice(1)
}

export function relationType (key) {
  if (detailsFields.includes(key)) {
    return 'input'
  }
  return 'select'
}

export function useStateCallback (initialState) {
  const [ state, setState ] = useState(initialState)
  const cbRef = useRef(null) // init mutable ref container for callbacks
  const setStateCallback = useCallback((_state, cb) => {
    cbRef.current = cb
    setState(_state)
  }, [])

  useEffect(() => {
    if (cbRef.current) {
      cbRef.current(state)
      cbRef.current = null
    }
  }, [ state ])
  return [ state, setStateCallback ]
}

export const domains = {
  Nx: (

    <div className={cx(styles.icons, styles.lightGreen, styles.square)}>
      <span>Nx</span>
    </div>
  ),
  Vx: (
    <div className={cx(styles.icons, styles.yellow, styles.square)}>
      <span>Vx</span>
    </div>
  ),
  Tx: (
    <div className={cx(styles.icons, styles.darkPurple)}>
      <span>Tx</span>
    </div>
  ),
  Gx: (
    <div className={cx(styles.icons, styles.darkRed)}>
      <span>Gx</span>
    </div>
  ),
  Ox: (
    <div className={cx(styles.icons, styles.lightPink)}>
      <span>Ox</span>
    </div>
  ),
  Sx: (
    <div className={cx(styles.icons, styles.darkBlue)}>
      <span>Sx</span>
    </div>
  ),
  Px: (
    <div className={cx(styles.icons, styles.peach, styles.square)}>
      <span>Px</span>
    </div>
  ),
  Hx: (
    <div className={cx(styles.icons, styles.teal, styles.square)}>
      <span>Hx</span>
    </div>
  ),
  Rx: (
    <div className={cx(styles.icons, styles.orange, styles.square)}>
      <span>Rx</span>
    </div>
  ),
  Ex: (
    <div className={cx(styles.icons, styles.red, styles.square)}>
      <span>Ex</span>
    </div>
  ),
  Ax: (
    <div className={cx(styles.icons, styles.blue)}>
      <span>Ax</span>
    </div>
  ),
  Fx: (
    <div className={cx(styles.icons, styles.pink)}>
      <span>Fx</span>
    </div>
  ),
  Kx: (
    <div className={cx(styles.icons, styles.purple)}>
      <span>Kx</span>
    </div>
  ),
  Bx: (
    <div className={cx(styles.icons, styles.lightBlue)}>
      <span>Bx</span>
    </div>
  )
}

export function prepareStatus (key, id, user, currentStatus) {
  if (key === 'assignee') {
    return user === id ? 'in-progress' : 'not-started'
  }
  return key === 'status' ? id : currentStatus
}

const isDraft = iss =>
  iss.draft || iss.diff || iss.actions?.some(act => act.diff || act.draft)

export function filterItemsByStatus (item, filters) {
  if (item) {
    let tempItem = [ ...item ]
    if (filters?.status) {
      if (filters?.status?.length > 0) {
        tempItem = tempItem
          ?.filter(
            i =>
              filters.status?.includes(i.details.find(dv => dv.key === 'status')
                .id) ||
              isDraft(i)
          )
      }

      return tempItem?.sort(
        (prev, next) => new Date(next.createdAt) - new Date(prev.createdAt)
      ) || []
    }

    const isIssues = tempItem.some(i => Object.prototype.hasOwnProperty.call(i ?? {}, 'domain'))

    if (filters?.issue?.length > 0 && isIssues) {
      tempItem = tempItem
        ?.filter(
          i =>
            filters.issue?.includes(i.details.find(dv => dv.key === 'status')
              .id) ||
            isDraft(i)
        )
    }

    if (filters?.action?.length > 0 && !isIssues) {
      tempItem = tempItem
        ?.filter(
          i =>
            filters.action?.includes(i.details.find(dv => dv.key === 'status')
              .id) ||
            isDraft(i)
        )
    }

    if (filters?.assignee?.length > 0) {
      tempItem = tempItem
        ?.filter(
          i => filters.assignee?.includes(i.details.find(dv => dv.key === 'assignee').id) ||
            i.actions?.some(a => filters.assignee.includes(a.details.find(dv => dv.key === 'assignee').id)) ||
            isDraft(i)
        )
    }

    if (filters.page.length > 0) {
      tempItem = tempItem
        ?.filter(
          i => filters.page?.includes(i.page) || isDraft(i)
        )
    }
    return tempItem?.sort(
      (prev, next) => new Date(next.createdAt) - new Date(prev.createdAt)
    ) || []
  }
  return []
}

export function favorable (unfavorable) {
  if (typeof unfavorable !== 'string') {
    return null
  }
  return unfavorable === 'yes' ? 'no' : 'yes'
}

export function isFavorable (item) {
  if (!item.answer) return false
  return favorable(item.unfavorable) === item?.answer
}

export function notEditableItem (item) {
  if (cancelledOrCompleted(item) && !item.draft) {
    if (!item?.diff) return true
    if (
      Object.keys(item?.diff)
        .length === 1 &&
      Object.keys(item?.diff)
        .includes('comment')
    ) {
      return true
    }
  } else {
    return false
  }
  return false
}

export function withDivider (previousItem, filter) {
  if (!previousItem) {
    return
  }

  if (headerType.includes(previousItem.type)) {
    return null
  }

  if (filterItemsByStatus(previousItem?.issues, filter)
    ?.length === 0) {
    return <Divider />
  }

  return null
}

export function findDiff (item, key) {
  if (!item?.draft) {
    return item?.diff?.[key] ?? null
  }
  return null
}

export function validateNewAction (issue, state) {
  const isDuplicate = issue.actions
    ?.filter(act => !cancelledOrCompleted(act))
    .some(
      act => act?.description?.trim() === state.current?.action?.text?.trim()
    )
  return !isDuplicate
}

export function templateNewAction (state, lists) {
  return ({
    id: uid(),
    logs: [],
    description: state.current.action.text,
    createdAt: new Date().toISOString(),
    urgent: state.current.action.urgent,
    statusChanged: new Date().toISOString(),
    comment: [],
    draft: true,
    details: [
      {
        id: state.current.action.assignee,
        key: 'assignee',
        name: lists.assignee.find(l => l.id === state.current.action.assignee)
          .name
      },
      {
        id: state.current.action.status,
        key: 'status',
        name: lists.status.find(l => l.id === state.current.action.status)
          .name
      }
    ],
    dueDate:
      new Date(state.current.action.dueDate).toISOString() ||
      moment(new Date()).add(1, 'days').toDate()
  })
}

export function findById (items, id) {
  return items.find(i => i.id === id)
}

export function prepareName (key) {
  return relationName[key]
}

export const igaoPagesOrder = {
  csr: 0,
  patient: 1,
  insurances: 2,
  home_assessment: 3,
  family_support: 4,
  provider_network: 5,
  diagnosis: 6,
  admissions: 7,
  maternity: 8,
  lifestyle: 9,
  resources: 10,
  substance_use: 11,
  tribal: 12,
  medications: 13,
  esas: 14,
  behavioral: 15,
  review_of_systems: 16,
  vitals: 17,
  general_documents: 18,
  goals: 19
}
